module.exports = __webpack_public_path__ + "media/images/pages/peel-case/case-2-f93c2d2ca5a36cbccc006d1d7d0118f0.png";